(() => {
  if (window.__sketchlinePdpReady) return;
  window.__sketchlinePdpReady = true;

  const mobile = window.matchMedia('(max-width: 749px)');
  const desktop = window.matchMedia('(min-width: 990px)');
  const colourMap = [
    ['graphite heather', '#55565a'], ['dark heather', '#4b4b4d'],
    ['heather navy', '#31445d'], ['heather royal', '#416aa3'],
    ['sport grey', '#a9aaad'], ['ash', '#c7c7c5'], ['charcoal', '#45484c'],
    ['black', '#111111'], ['white', '#f6f4ee'], ['navy', '#18263f'],
    ['royal', '#2458a6'], ['light blue', '#9fc7df'], ['jade dome', '#568f86'],
    ['military green', '#596447'], ['forest green', '#244d35'],
    ['irish green', '#2c9b58'], ['maroon', '#6e2939'], ['red', '#c9353e'],
    ['orange', '#dc6d2d'], ['yellow', '#e4c84b'], ['purple', '#68477f'],
    ['pink', '#d99aab'], ['sand', '#c8b596'], ['natural', '#ded2bb'],
    ['brown', '#6c4939'], ['grey', '#888b8e'], ['gray', '#888b8e'],
    ['blue', '#537eae'], ['green', '#4f7656']
  ];

  const clean = value => (value || '').replace(/\s*-\s*(sold out|unavailable).*$/i, '').trim();
  const currentValue = select => clean(select.options[select.selectedIndex]?.text || '');
  const swatchFor = value => {
    const lower = value.toLowerCase().trim();
    return (colourMap.find(([name]) => lower.includes(name)) || [null, '#777b82'])[1];
  };

  function enhanceOption(wrapper, mode) {
    const classPrefix = mode === 'mobile' ? 'gpt-mobile' : 'gpt-desktop';
    const enhancedClass = `${classPrefix}-enhanced`;
    if (wrapper.classList.contains(enhancedClass)) return;

    const select = wrapper.querySelector('select');
    if (!select) return;

    const sourceLabel = wrapper.querySelector('label');
    const label = (sourceLabel?.textContent || select.name || 'Option').replace(/:.*$/, '').trim();
    const isColour = /colou?r/i.test(label);
    const isSize = /size/i.test(label);

    const block = document.createElement('div');
    block.className = `${classPrefix}-variant${isColour ? ` ${classPrefix}-color` : ''}${isSize ? ` ${classPrefix}-size` : ''}`;

    const heading = document.createElement('div');
    heading.className = `${classPrefix}-variant-heading`;

    const strong = document.createElement('strong');
    strong.textContent = `${label}:`;

    const selected = document.createElement('span');
    selected.className = `${classPrefix}-current-value`;

    heading.append(strong, selected);

    const buttons = document.createElement('div');
    buttons.className = `${classPrefix}-variant-buttons`;
    buttons.setAttribute('role', 'group');
    buttons.setAttribute('aria-label', label);

    const rebuildButtons = () => {
      const existing = new Map(
        [...buttons.querySelectorAll('button')].map(button => [button.dataset.value, button])
      );

      [...select.options].forEach(option => {
        let button = existing.get(option.value);
        if (!button) {
          button = document.createElement('button');
          button.type = 'button';
          button.dataset.value = option.value;
          button.className = `${classPrefix}-variant-button${isColour ? ` ${classPrefix}-color-button` : ''}`;
          button.addEventListener('click', () => {
            if (button.disabled) return;
            select.value = button.dataset.value;
            select.dispatchEvent(new Event('change', { bubbles: true }));
            requestAnimationFrame(sync);
          });
          buttons.append(button);
        }

        const text = clean(option.text);
        button.textContent = text;
        button.title = text;
        button.setAttribute('aria-label', `${label} ${text}`);
        button.disabled = option.disabled;

        if (isColour) {
          button.style.setProperty(
            mode === 'mobile' ? '--gpt-swatch' : '--gpt-desktop-swatch',
            swatchFor(text)
          );
        }
        existing.delete(option.value);
      });

      existing.forEach(button => button.remove());
    };

    const sync = () => {
      rebuildButtons();
      selected.textContent = currentValue(select);
      buttons.querySelectorAll('button').forEach(button => {
        const active = button.dataset.value === select.value;
        button.classList.toggle('is-selected', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    };

    select.addEventListener('change', () => requestAnimationFrame(sync));
    block.append(heading, buttons);
    wrapper.insertBefore(block, wrapper.firstChild);
    wrapper.classList.add(enhancedClass);
    sync();
  }

  function moveReview(details, mode) {
    const className = mode === 'mobile' ? 'gpt-mobile-review-badge' : 'gpt-desktop-review-badge';
    if (details.querySelector(`.${className}`)) return;

    const badge = document.querySelector('.jdgm-prev-badge, .jdgm-preview-badge');
    if (!badge) return;

    badge.classList.add(className);
    (details.querySelector('.group-block') || details).prepend(badge);
  }

  function enhancePrice(details, mode) {
    const priceBlock = details.querySelector('product-price') || details.querySelector('.price')?.parentElement;
    if (!priceBlock) return;

    const saleClass = mode === 'mobile' ? 'gpt-sale-badge' : 'gpt-desktop-sale-badge';
    const shippingClass = mode === 'mobile' ? 'gpt-shipping-note' : 'gpt-desktop-shipping-note';
    const compare = priceBlock.querySelector('.compare-at-price, s, del');

    if (compare?.textContent.trim() && !priceBlock.querySelector(`.${saleClass}`)) {
      const badge = document.createElement('span');
      badge.className = saleClass;
      badge.textContent = 'Sale';
      (priceBlock.querySelector('.price') || priceBlock).append(badge);
    }

    /*
if (!priceBlock.parentElement?.querySelector(`:scope > .${shippingClass}`)) {
  const note = document.createElement('div');
  note.className = shippingClass;
  note.textContent = 'Shipping calculated at checkout.';
  priceBlock.insertAdjacentElement('afterend', note);
}
*/
  }

  function placeAfterpay(details, mode) {
    const addButton = details.querySelector('.add-to-cart-button');
    const placement = details.querySelector('afterpay-placement, square-placement, [data-afterpay-placement]');
    if (!addButton || !placement) return;

    const anchor = addButton.closest('.product-form-buttons');
    const afterpayBlock =
      placement.closest('.shopify-block, [id^="shopify-block-"], .app-block') ||
      placement.parentElement ||
      placement;

    if (!anchor || !afterpayBlock || anchor.contains(afterpayBlock)) return;

    if (mode === 'mobile') {
      afterpayBlock.classList.add('gpt-afterpay-moved', 'gpt-afterpay-directly-under-atc');
    } else {
      afterpayBlock.classList.add('gpt-desktop-afterpay');
    }

    if (anchor.nextElementSibling !== afterpayBlock) {
      anchor.insertAdjacentElement('afterend', afterpayBlock);
    }
  }

  function addTrust(details) {
    if (details.querySelector('.gpt-trust-line')) return;
    const buy = details.querySelector('.buy-buttons-block');
    if (!buy) return;

    const line = document.createElement('div');
    line.className = 'gpt-trust-line';
    line.textContent = 'Original Australian ink-sketch tees · Printed to order';
    buy.insertAdjacentElement('afterend', line);
  }
function updatePrintLocation(details) {
  const options = [
    ...details.querySelectorAll('.variant-option--dropdowns, .variant-option')
  ];

  const findOption = (pattern) =>
    options.find((wrapper) => {
      const heading =
        wrapper.querySelector('legend')?.textContent ||
        wrapper.textContent ||
        '';

      return pattern.test(heading.trim());
    });

  const getSelectedValue = (wrapper) => {
    if (!wrapper) return '';

    return (
      wrapper.querySelector('input[type="radio"]:checked')?.value ||
      wrapper.querySelector('select')?.value ||
      wrapper.querySelector('[data-selected-value]')?.textContent ||
      ''
    ).trim();
  };

  const colourWrapper = findOption(/^(color|colour)\s*:/i);
  if (!colourWrapper) return;

  const sizeWrapper = findOption(/^size\s*:/i);
  const colour = getSelectedValue(colourWrapper).toLowerCase();
  const size = getSelectedValue(sizeWrapper).toLowerCase();

  const australianColours = new Set([
    'sport grey',
    'black',
    'white',
    'navy',
    'dark heather',
    'royal',
    'orange'
  ]);

  const redAustralianSizes = new Set(['s', 'm', 'l', 'xl', '2xl']);

  const printedInAustralia =
    australianColours.has(colour) ||
    (colour === 'red' && redAustralianSizes.has(size));

  let badge = colourWrapper.querySelector(':scope > .gpt-print-location');

  if (!badge) {
    badge = document.createElement('span');
    badge.className = 'gpt-print-location';

    Object.assign(badge.style, {
      position: 'absolute',
      top: '0',
      right: '0',
      fontSize: '12px',
      fontWeight: '600',
      lineHeight: '1.3',
      whiteSpace: 'nowrap',
      pointerEvents: 'none',
      zIndex: '1'
    });

    colourWrapper.style.position = 'relative';
    colourWrapper.append(badge);
  }

  badge.textContent = printedInAustralia
    ? '🇦🇺 AU print'
    : '🇺🇸 USA print · Select 🇦🇺 colour';

  badge.style.color = printedInAustralia ? '#285584' : '#555555';

  if (!details.dataset.printLocationBound) {
    details.addEventListener('change', () => {
      requestAnimationFrame(() => updatePrintLocation(details));
    });

    details.dataset.printLocationBound = 'true';
  }
}
  function apply(root) {
    const details = root.querySelector('.product-details') || (root.matches?.('.product-details') ? root : null);
    if (!details) return;

    const mode = mobile.matches ? 'mobile' : desktop.matches ? 'desktop' : null;
    if (!mode) return;

    details
      .querySelectorAll('.variant-option--dropdowns, .variant-option')
      .forEach(wrapper => enhanceOption(wrapper, mode));

    moveReview(details, mode);
    enhancePrice(details, mode);
    placeAfterpay(details, mode);
    // updatePrintLocation(details);

    if (mode === 'mobile') addTrust(details);
  }

  function start() {
    const details = document.querySelector('.product-details');
    if (!details) return;

    const root = details.closest('.product-information') || details;
    apply(root);

    let queued = false;
    const observer = new MutationObserver(() => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => {
        queued = false;
        apply(root);
      });
    });

    observer.observe(root, { childList: true, subtree: true });

    const reloadOnBreakpointChange = () => location.reload();
    mobile.addEventListener?.('change', reloadOnBreakpointChange);
    desktop.addEventListener?.('change', reloadOnBreakpointChange);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
